export class ItemOperationError extends Error {
    constructor(message: string){
        super(message);
        this.name = 'ItemOperationError';
    }
}